import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import CurrencyConverter from "../../Currency/CurrencyConverter";

const CheckoutOrderSummary = ({
  handleNext,
  totalAmount,
  items,
  register,
  buyerName,
  buyerID,
  amount,
  formValues,
}) => {
  const { t } = useTranslation();

  const userSelectedCurrency = useSelector(
    (state) => state.user?.selectedCurrency
  );
  const conversionFactor = useSelector(
    (state) => state?.user?.conversionFactor
  );
  return (
    <>
      <div className="checkout_list_scrl">
        <div className="form-container">
          <p>
            <strong>Company Name:</strong> SMART PERU REAL STATE SAC
          </p>
          <p>
            <strong>Single Taxpayer Registry:</strong> 20605473068
          </p>
          <p>
            <strong>Address:</strong> Av. El Derby 254, Office 1204, Urb. El
            Derby de Monterrico, Lima.
          </p>
          <p>
            <strong>Legal Representative:</strong> CARLO ERNESTO PONCE DE LEON
            GUTIERREZ
          </p>
          <p>
            <strong>Identity Document (Attorney):</strong> 47092207
          </p>

          <h3>The Buyer</h3>
          <input
            {...register("buyerName")}
            placeholder="Full Name"
            className="input-field"
          />
          <br />
          <input
            {...register("nationality")}
            placeholder="Nationality"
            className="input-field"
          />
          <br />
          <input
            {...register("idType")}
            placeholder="Type of Identity Document"
            className="input-field"
          />
          <br />
          <input
            {...register("buyerID")}
            placeholder="Identity Document Number"
            className="input-field"
          />
          <br />
          <input
            {...register("maritalStatus")}
            placeholder="Marital Status"
            className="input-field"
          />
          <br />
          <input
            {...register("occupation")}
            placeholder="Profession or Occupation"
            className="input-field"
          />
          <br />
          <input
            {...register("home")}
            placeholder="Home"
            className="input-field"
          />
          <br />
          <input
            {...register("email")}
            placeholder="Email"
            type="email"
            className="input-field"
          />
          <br />

          <h3>The Real Estate Unit</h3>
          <input
            {...register("realEstateUnit")}
            placeholder="Signed As"
            className="input-field"
          />
          <br />
          <input
            {...register("area")}
            placeholder="Approximate Area (m2)"
            className="input-field"
          />
          <br />

          <h3>Agreement Price</h3>
          <input
            {...register("totalPrice")}
            placeholder="Total Price (USD)"
            type="number"
            className="input-field"
          />
          <br />
          <input
            {...register("amount")}
            placeholder="Separation Amount (USD)"
            type="number"
            className="input-field"
          />
          <br />
          <select {...register("paymentMethod")} className="input-field">
            <option value="cash">Cash</option>
            <option value="financed">Financed</option>
          </select>
          <br />

          <h3>Summary</h3>
          <p>
            <strong>Buyer Name: </strong>
            {buyerName}
          </p>
          <p>
            <strong>Buyer ID:</strong> {buyerID}{" "}
          </p>
          <p>
            <strong>Separation Amount:</strong> {amount} USD
          </p>

          <h3>Signatures</h3>
          <p>
            <strong>Buyer Signature:</strong>{" "}
            <img
              style={{
                maxHeight: "230px",
                maxWidth: "153px",
                border: "1px solid black",
              }}
              src={formValues?.signature}
              alt="Digital Signature"
            />
          </p>
          {/* <p><strong>Seller Signature:</strong> _______________________</p> */}
        </div>
      </div>

      <div className="checkout_continuew_btn">
        <button
          className="btn btn-primary checkout_cnt_btn"
          onClick={handleNext}
        >
          {t("continue")}
        </button>
      </div>
    </>
  );
};

export default CheckoutOrderSummary;
